import FetchService from "./Shared/FetchService";
import SurveyResponseDomainService from "../Domain/SurveyResponse/SurveyResponse.service";
const BASE_URL = "/aviso/surveyResponse";
export default class SurveyResponseService {
    static search(search, options = {}) {
        return FetchService.getPagedResponse(BASE_URL + "/search", {
            ids: search === null || search === void 0 ? void 0 : search.ids,
            srcSystemIds: search === null || search === void 0 ? void 0 : search.srcSystemIds,
            surveyIds: search === null || search === void 0 ? void 0 : search.surveyIds,
            recipientIds: search === null || search === void 0 ? void 0 : search.recipientIds,
            senderIds: search === null || search === void 0 ? void 0 : search.senderIds,
            regardingIds: search === null || search === void 0 ? void 0 : search.regardingIds,
            createdByIds: search === null || search === void 0 ? void 0 : search.createdByIds,
            statusIds: search === null || search === void 0 ? void 0 : search.statusIds,
            max: options === null || options === void 0 ? void 0 : options.max,
            offset: options === null || options === void 0 ? void 0 : options.offset,
            sort: options === null || options === void 0 ? void 0 : options.sort,
            order: options === null || options === void 0 ? void 0 : options.order,
            query: search === null || search === void 0 ? void 0 : search.query,
        }).then((response) => (Object.assign(Object.assign({}, response), { 
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            data: response === null || response === void 0 ? void 0 : response.data.map(SurveyResponseDomainService.fromJSON) })));
    }
    static deleteSurveyResponses(responses) {
        return FetchService.deleteSingleResponse(BASE_URL + "/deleteSurveyResponses", {
            surveyResponseIds: responses.map((surveyResponse) => surveyResponse.id),
        });
    }
}
